<template>
  <div class="addOnlineContainer">
    <section>
      <h2>
        一、月工单
        <a @click="exampleMonth">[ {{ downloadMonthTxt }} ]</a>
      </h2>
      <div class="hint">
        <h3>注意事项</h3>
        <span>1、 必须为.xls或.xlsx结尾的excel；</span>
        <span>2、表格中不得有空行空列，无数据填0；</span>
        <span>3、表格中所有数据均为文本格式；</span>
        <span>4、表格中日期格式以-作为连接符(如2020-10)。</span>
      </div>
      <div>
        <label><i>*</i>选择项目：</label>
        <a-select
          style="width: 300px"
          showSearch
          :filterOption="filterOption"
          v-model="proIDMonth"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </div>
      <div>
        <label><i>*</i>结算表：</label>
        <input type="file" @change="excelDataMonth" :value="excelValMonth" />
      </div>
      <a-button type="primary" @click="submitUploadMonth">{{
        upTxtMonth
      }}</a-button>
    </section>
    <!-- <section class="downloadStyle">
      <h2>二、月工单</h2>
      <div>
        <label>日期：</label>
        <a-month-picker @change="downloadMonth" />
      </div>
      <div>
        <label>选择项目：</label>
        <a-select style="width: 300px" showSearch v-model="downloadProID">
          <a-select-option
            v-for="(item,i) in proList"
            :key="i"
            :value="item.id"
          >{{item.project_name}}</a-select-option>
        </a-select>
      </div>
      <a-button type="primary" @click="downloadExcel">{{downloadFollowTxt}}</a-button>
    </section>-->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 2 },
        wrapperCol: { span: 6 }
      },
      proList: [],
      downloadMonthTxt: "下载示例Excel",
      proIDMonth: "",
      excelValMonth: "",
      attenceMonth: "",
      attenceFileMonth: "",
      upTxtMonth: "上传"
    };
  },
  mounted() {
    this.getPro(); //项目
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    exampleMonth() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Retail_order/downloadTplMonth?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    excelDataMonth(e) {
      this.attenceMonth = e.target.files[0].name;
      this.attenceFileMonth = e.target.files[0];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    submitUploadMonth() {
      let _this = this;
      if (this.attenceFileMonth != "" && this.proIDMonth != "") {
        this.$confirm({
          title: "上传该项目结算信息，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcelMonth();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("标记*为必填项");
      }
    },
    upExcelMonth() {
      this.upTxtMonth = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.attenceFileMonth);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      formData.append("project_id", this.proIDMonth);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Retail_order/uploadMonth";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.proIDMonth = "";
            this.attenceFileMonth = "";
            this.$emit("hideInAdd", false);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {}
            });
            // this.$message.warning();
          }
          this.upTxtMonth = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxtMonth = "上传";
    },
    downloadExcel() {
      // console.log(this.month)
      this.downloadMonthTxt = "下载中...";
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Retail_order/downloadTplMonth?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&month=" +
        this.month +
        "&project_id=" +
        this.downloadProID;
      this.downloadMonthTxt = "下载";
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  padding: 30px 4%;
  > section {
    margin-bottom: 50px;
    label {
      font-size: 14px;
      i {
        font-style: normal;
        color: red;
        display: inline-block;
        margin-right: 4px;
      }
    }
    > div {
      margin-top: 10px;
    }
    h2 {
      margin-bottom: 30px;
      font-weight: normal;
      a {
        font-size: 14px;
        display: inline-block;
        margin-left: 20px;
      }
    }
    input {
      margin: 20px 30px;
    }
    button {
      display: block;
      margin-left: 70px;
    }
  }

  .downloadStyle {
    margin-top: 30px;
    button {
      margin-top: 20px;
    }
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
